import {createAction} from "redux-act";

export const subscribeToLiveScores = createAction();
export const unsubscribeFromLiveScores = createAction();
